import { ref } from 'vue'
import type { Router } from 'vue-router'

export const updateAvailable = ref(false)

let serverHash: string | null = null
const RELOADED_FOR = 'update-checker:reloaded-for'

export function applyUpdate() {
    if (serverHash) sessionStorage.setItem(RELOADED_FOR, serverHash)
    location.reload()
}

function isBusyPath(path: string) {
    return path.includes('/contador/')
        || path.includes('/contagens/editar/')
        || /^\/recebimento-produtos\/[^/]+/.test(path)
}

async function getServerBuildHash() {
    try {
        const res = await fetch('/', { cache: 'no-store' })
        const html = await res.text()
        return html.match(/<meta name="build-hash" content="([^"]+)">/)?.[1] ?? null
    } catch (err) {
        console.error('Erro ao buscar hash do servidor', err)
        return null
    }
}

async function checkBuildVersion() {
    if (updateAvailable.value) return
    const localHash = document
        .querySelector('meta[name="build-hash"]')
        ?.getAttribute('content')
    const next = await getServerBuildHash()
    if (!next || next === localHash) return
    serverHash = next
    updateAvailable.value = true
}

export function setupUpdateCheckerRouter(router: Router) {
    router.afterEach((to, from) => {
        if (!updateAvailable.value) return
        if (!isBusyPath(from.path) || isBusyPath(to.path)) return
        if (serverHash && sessionStorage.getItem(RELOADED_FOR) === serverHash) return
        applyUpdate()
    })
}

async function start() {
    await checkBuildVersion()
    if (!updateAvailable.value) setTimeout(start, 120_000)
}

start()
